import React, { Component } from 'react';
import Helmet from "react-helmet";
import { lang } from '../../../il8n/lang';
import { connect } from 'react-redux';
import Caro from '../../Carousels/Caro/Caro';
import Collectioncaro from '../../Collectioncaro/Collectioncaro';
import Productcaro from '../../Productcaro/Productcaro';
import Variants from '../../Variants/Variants'
import GeneralModal from '../../GeneralModal/GeneralModal';
import VideoPlayer from '../../VideoPlayer/VideoPlayer';
import WhereToBuy from '../../WhereToBuy/WhereToBuy';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import { mapATGLoc } from '../../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faArrowRight, faArrowLeft, faTimes, faPlayCircle} from '@fortawesome/free-solid-svg-icons';

import { toggleInterstitial } from '../../../Actions/Index';
import './Home.css';

/**
 * Home
 * @constructor
 */

class Home extends Component {
  constructor(props){
    super(props);
    this.state = {
      modalOpen: false,
    };

    this.toggleModal = this.toggleModal.bind(this);


  }
  componentDidMount(){
    this.props.dispatch(toggleInterstitial(false, '', ''))
  }

  toggleModal(vid){
    this.setState(state => ({
      modalOpen: !state.modalOpen,
      currentvid: vid
    }));
  }
  render() {
    let {gaToggle} = this.props;
    return (
        <div>
            <Helmet title={lang.home.title + lang.helmet.siteTitle} />
            <GeneralModal
                open={this.state.modalOpen}
                toggleModal={this.toggleModal}>
                <VideoPlayer
                    type={'default'}
                    activeVid={this.state.currentvid}
                    warn={lang.warnings.enableIframes}
                    autoPlay={true}
                    loop={false}
                />
            </GeneralModal>
            <div className="home">
                {/* {this.renderHomeBanner()} */}
                {lang.home.slides.length > 1 ?
        <Caro respSlidesToShow={1} slidesToShow={1} frameOverflow={false} insertClass={'caro--homebanner'}>
            {lang.home.slides.map((slide, index) => {
              let img =  this.state.mobileView ? slide.mobileImg : slide.img;
              console.log(lang.getLanguage(), "this is get language")
              return(
                <div className={`banner-container ${slide.bgClass}`}>
                <div className="wrap">
                  <div className={`flex-row mod-${slide.classImg}`}>
                    <div className="flex-col-sm-1 no-padding">
                      </div>

                  
                  <div className="flex-col-sm-4 no-padding">
                    <div className={`caro__desc mod-${slide.class}`}>
                        <div className='custombanner'>
                          <img className="banner-logo" src={slide.logo} alt={slide.logo_alt} /> 
                          <h1 className='slideBannerHeading'>{slide.heading}</h1>
                          <p>{slide.subheading}</p>
                          <div className="cta-container">
                            {/* {slide.ctas.map(cta => {
                            return (
                              cta.cta_label == 'Learn More' ?
                                (<Link to={`/${lang.getLanguage()}${cta.cta_link}`} >
                                  <button
                                    onClick={()=>this.toggleModal(cta.cta_media)}
                                  >{cta.cta_label}</button>
                                </Link>) :
                                (<a href={`${cta.cta_link}`} target="_blank">
                                  <button>{cta.cta_label}</button>
                                </a>)
                              )
                            })} */}
                                {slide.ctas.map(cta => {
                                // console.log(lang.getLanguage(), "this is get lang")
                                if(cta.cta_type === 'internal') {
                                    return (
                                    <Link to={`/${lang.getLanguage()}${cta.cta_link}`} >
                                    <button
                                      onClick={()=>this.toggleModal(cta.cta_link)}
                                    >{cta.cta_label}</button>
                                  </Link>);
                                } else if (cta.cta_type === "video") {
                                return(
                                    <div>
                                    <button
                                    onClick={()=>this.toggleModal(cta.cta_link)}
                                  >{cta.cta_label}</button>
                                    </div>
                                )
                                }
                                else {
                                    return (<a href={`${cta.cta_link}`} target="_blank">
                                        <button>{cta.cta_label}</button>
                                    </a>);
                                }
                            })}
                          </div>
                        </div>
                    </div>
                  </div>

                  <div className="flex-col-sm-6 no-padding">
                    <div className={`caro__item`} key={slide.heading+index}>
                      <div className={`caro__img mod-${slide.classImg}`}>
                        <img  
                          alt={slide.heading} 
                          src={img} 
                        />
                      </div>
                    </div>
                  </div>
                  
                </div>
                </div>
                </div>
              )
              })
            }
            </Caro>
            :
            <div>
                {lang.slides.map((slide, index) => {
                    let img = this.state.mobileView
                        ? slide.mobileImg
                        : slide.img;
                    return (
                        <div
                            className={`banner-container ${
                                lang.getLanguage() === 'en_us' || 'en_gb' || 'en_ca'
                                    ? slide.bgClass
                                    : ''
                            }`}>
                            <div className="wrap">
                                <div
                                    className={`flex-row mod-${slide.classImg} flex-col-reverse-mobile`}>
                                    <div className="flex-col-sm-1 no-padding"></div>

                                    <div className="flex-col-sm-4 no-padding">
                                        <div
                                            className={`caro__desc mod-${slide.class}`}>
                                            <div className="custombanner">
                                                <img
                                                    className="banner-logo"
                                                    src={slide.logo}
                                                    alt={slide.logo_alt}
                                                />
                                                <h1 className="slideBannerHeading">
                                                    {slide.heading}
                                                </h1>
                                                <p>{slide.subheading}</p>
                                                <div className="cta-container">
                             {slide.ctas.map(cta => {
                                // console.log(lang.getLanguage(), "this is get lang")
                                if(cta.cta_type === 'internal') {
                                    return (
                                    <Link to={`/${lang.getLanguage()}${cta.cta_link}`} >
                                    <button
                                      onClick={()=>this.toggleModal(cta.cta_link)}
                                    >{cta.cta_label}</button>
                                  </Link>);
                                } else if (cta.cta_type === "video") {
                                return(
                                    <div>
                                    <button
                                    onClick={()=>this.toggleModal(cta.cta_link)}
                                  >{cta.cta_label}</button>
                                    </div>
                                )
                                }
                                else {
                                    return (<a href={`${cta.cta_link}`} target="_blank">
                                        <button>{cta.cta_label}</button>
                                    </a>);
                                }
                            })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex-col-sm-6 no-padding">
                                        <div
                                            className={`caro__item`}
                                            key={slide.heading + index}>
                                            <div
                                                className={`caro__img mod-${slide.classImg}`}>
                                                <img
                                                    alt={slide.heading}
                                                    src={img}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
</div>          
  }
                {!!lang.home.promoBlocks.hp_hero_video_block && 
                <div className={`section promoblock section--altBg ${lang.home.promoBlocks.hp_hero_video_block.class}`}>
                    <div className="flex-container">
                        <div className="flex-row">
                            <div className="hero_videoposter_wrapper">
                                <img
                                    className="imageclass videoPrimaryImage"
                                    src={
                                        lang.home.promoBlocks
                                            .hp_hero_video_block
                                            .hp_video_img
                                    }
                                    alt={
                                        lang.home.promoBlocks
                                            .hp_hero_video_block
                                            .hp_video_alt
                                    }
                                    onClick={() =>
                                        this.toggleModal(
                                            lang.home.promoBlocks
                                                .hp_hero_video_block.hp_video
                                        )
                                    }
                                    
                                    ></img>
                            </div>
                        </div>
                    </div>

                </div>
                
                }

                {/* <div className="wrap">
                    <div className="retailers" id="wheretobuy">
                        <div className="wtb_header">
                            <h2>{lang.home.sections.retailers.header} </h2>
                        </div>
                        <div className="retailers-list">
                            {lang.home.sections.retailers.retailers.map(
                                (retailer, index) => (
                                    <div
                                        className="retailer"
                                        key={`retailers___${index}`}>
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={() => {
                                                if (retailer.href !== '') {
                                                    this.props.dispatch(
                                                        toggleInterstitial(
                                                            true,
                                                            retailer.href
                                                        )
                                                    );
                                                }
                                            }}>
                                            <img
                                                className="retailer-img"
                                                id={`${retailer.id}`}
                                                src={retailer.img}
                                                alt={retailer.name}
                                            />
                                        </a>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div> */}
                <div className="wtb_first">
                    <WhereToBuy />
                </div>

                {/*popstyle SECTION************************************************************/}
                {!!lang.home.promoBlocks.popstyle_block && 
                <div className={`section promoblock section--altBg hp_firstblock_single ${lang.home.promoBlocks.popstyle_block.class}`}>
                    <div className="flex-container">
                        <div className="flex-row">
                            <div className="flex-col-sm-7">
                                <img
                                    className={
                                        lang.home.promoBlocks
                                            .popstyle_block.imgClass
                                    }
                                    src={
                                        lang.home.promoBlocks
                                            .popstyle_block.img
                                    }
                                    alt={
                                        lang.home.promoBlocks
                                            .popstyle_block.title
                                    }
                                />
                            </div>

                            <div className="flex-col-sm-5">
                                <img
                                    className="hp_firstblock_single-logo"
                                    src={
                                        lang.home.promoBlocks
                                            .popstyle_block.logo
                                    }
                                    alt={
                                        lang.home.promoBlocks
                                            .popstyle_block.alt
                                    }
                                />
                                <p>
                                    {
                                        lang.home.promoBlocks
                                            .popstyle_block.desc
                                    }
                                </p>

                                <div
                                    className="hp_videoposter">
                                    <img
                                        className="imageclass videoPrimaryImage"
                                        src={
                                            lang.home.promoBlocks
                                                .popstyle_block
                                                .hp_video_img
                                        }
                                        alt={
                                            lang.home.promoBlocks
                                                .popstyle_block
                                                .hp_video_alt
                                        }></img>
                                        <span className="videoSpan" onClick={() =>
                                            this.toggleModal(
                                                lang.home.promoBlocks
                                                    .popstyle_block.hp_video
                                            )
                                        }>
                                            {/* <FontAwesomeIcon className="collection-selected__header__icon videoThumbImage" icon={faPlayCircle} size="lg" /> */}
                                        </span>
                                </div>
                                <div className="cta_wrapper">
                                    <Link
                                        to={`/${lang.getLanguage()}/toys/${
                                            lang.home.promoBlocks
                                                .popstyle_block.ctas[0]
                                                .link
                                        }`}>
                                        <button>
                                            {
                                                lang.home.promoBlocks
                                                    .popstyle_block
                                                    .ctas[0].label
                                            }
                                        </button>
                                    </Link>
                                    <a
                                        target="_blank"
                                        href={
                                            lang.home.promoBlocks
                                                .popstyle_block.ctas[1] &&
                                            lang.home.promoBlocks
                                                .popstyle_block.ctas[1]
                                                .link
                                        }>
                                        <button>
                                            {lang.home.promoBlocks
                                                .popstyle_block.ctas[1] &&
                                                lang.home.promoBlocks
                                                    .popstyle_block
                                                    .ctas[1].label}
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 }

            {/*Shimmer me SECTION************************************************************/}
                {!!lang.home.promoBlocks.shimmerme_block && 
                <div className={`section promoblock section--altBg hp_firstblock_single ${lang.home.promoBlocks.shimmerme_block.class}`}>
                    <div className="flex-container">
                        <div className="flex-row">

                            <div className="flex-col-sm-5">
                                <img
                                    className="hp_firstblock_single-logo"
                                    src={
                                        lang.home.promoBlocks
                                            .shimmerme_block.logo
                                    }
                                    alt={
                                        lang.home.promoBlocks
                                            .shimmerme_block.alt
                                    }
                                />
                                <p className="shimmerme_desc">
                                    {
                                        lang.home.promoBlocks
                                            .shimmerme_block.desc
                                    }
                                </p>

                                <div
                                    className="hp_videoposter">
                                    <img
                                        className="imageclass videoPrimaryImage"
                                        src={
                                            lang.home.promoBlocks
                                                .shimmerme_block
                                                .hp_video_img
                                        }
                                        alt={
                                            lang.home.promoBlocks
                                                .shimmerme_block
                                                .hp_video_alt
                                        }></img>
                                        <span className="videoSpan" onClick={() =>
                                            this.toggleModal(
                                                lang.home.promoBlocks
                                                    .shimmerme_block.hp_video
                                            )
                                        }>
                                            {/* <FontAwesomeIcon className="collection-selected__header__icon videoThumbImage" icon={faPlayCircle} size="lg" /> */}
                                        </span>
                                </div>
                                <div className="cta_wrapper">
                                    <Link
                                        to={`/${lang.getLanguage()}/toys/${
                                            lang.home.promoBlocks
                                                .shimmerme_block.ctas[0]
                                                .link
                                        }`}>
                                        <button>
                                            {
                                                lang.home.promoBlocks
                                                    .shimmerme_block
                                                    .ctas[0].label
                                            }
                                        </button>
                                    </Link>
                                    {/* <a
                                        target="_blank"
                                        href={
                                            lang.home.promoBlocks
                                                .popstyle_block.ctas[1] &&
                                            lang.home.promoBlocks
                                                .shimmerme_block.ctas[1]
                                                .link
                                        }>
                                        <button>
                                            {lang.home.promoBlocks
                                                .popstyle_block.ctas[1] &&
                                                lang.home.promoBlocks
                                                    .shimmerme_block
                                                    .ctas[1].label}
                                        </button>
                                    </a> */}
                                </div>
                            </div>

                            <div className="flex-col-sm-7">
                                <img
                                    className={
                                        lang.home.promoBlocks
                                            .shimmerme_block.imgClass
                                    }
                                    src={
                                        lang.home.promoBlocks
                                            .shimmerme_block.img
                                    }
                                    alt={
                                        lang.home.promoBlocks
                                            .shimmerme_block.title
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                 }

                {/*TEST PROMO SECTION************************************************************/}
                {!!lang.home.promoBlocks.hp_firstblock_single && 
                <div className={`section promoblock section--altBg hp_firstblock_single ${lang.home.promoBlocks.hp_firstblock_single.class}`}>
                    <div className="flex-container">
                        <div className="flex-row">
                            {/* <div className="flex-col-sm-6 mod-centered mod-bgimage" style={{'backgroundImage': 'url(https://via.placeholder.com/1900x650)'}}> */}
                            <div className="flex-col-sm-7">
                                <img
                                    className={
                                        lang.home.promoBlocks
                                            .hp_firstblock_single.imgClass
                                    }
                                    src={
                                        lang.home.promoBlocks
                                            .hp_firstblock_single.img
                                    }
                                    alt={
                                        lang.home.promoBlocks
                                            .hp_firstblock_single.title
                                    }
                                />
                            </div>
                            {/* </div> */}
                            <div className="flex-col-sm-5">
                                <img
                                    className="hp_firstblock_single-logo"
                                    src={
                                        lang.home.promoBlocks
                                            .hp_firstblock_single.logo
                                    }
                                    alt={
                                        lang.home.promoBlocks
                                            .hp_firstblock_single.alt
                                    }
                                />
                                <p>
                                    {
                                        lang.home.promoBlocks
                                            .hp_firstblock_single.desc
                                    }
                                </p>
                                {/* <a onClick={()=>{
                        this.toggleModal();
                        ReactGA.event({
                        category: 'video',
                        action: 'tvc view',
                        value: 'play'
                        });
                        }} >
                        <img className="hp_videoposter"  src={lang.home.promoBlocks.hp_firstblock_single.hp_video_img} 
                        alt={lang.home.promoBlocks.hp_firstblock_single.hp_video_alt} 
                        />
                        </a> */}
                                <div
                                    className="hp_videoposter">
                                    <img
                                        className="imageclass videoPrimaryImage"
                                        src={
                                            lang.home.promoBlocks
                                                .hp_firstblock_single
                                                .hp_video_img
                                        }
                                        alt={
                                            lang.home.promoBlocks
                                                .hp_firstblock_single
                                                .hp_video_alt
                                        }></img>
                                        <span className="videoSpan" onClick={() =>
                                            this.toggleModal(
                                                lang.home.promoBlocks
                                                    .hp_firstblock_single.hp_video
                                            )
                                        }>
                                            <FontAwesomeIcon className="collection-selected__header__icon videoThumbImage" icon={faPlayCircle} size="lg" />
                                        </span>
                                </div>
                                <div className="cta_wrapper">
                                    <Link
                                        to={`/${lang.getLanguage()}/toys/${
                                            lang.home.promoBlocks
                                                .hp_firstblock_single.ctas[0]
                                                .link
                                        }`}>
                                        <button>
                                            {
                                                lang.home.promoBlocks
                                                    .hp_firstblock_single
                                                    .ctas[0].label
                                            }
                                        </button>
                                    </Link>
                                    <a
                                        target="_blank"
                                        href={
                                            lang.home.promoBlocks
                                                .hp_firstblock_single.ctas[1] &&
                                            lang.home.promoBlocks
                                                .hp_firstblock_single.ctas[1]
                                                .link
                                        }>
                                        <button>
                                            {lang.home.promoBlocks
                                                .hp_firstblock_single.ctas[1] &&
                                                lang.home.promoBlocks
                                                    .hp_firstblock_single
                                                    .ctas[1].label}
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 }
            </div>

            {/*promo block*/}
            {!!lang.home.promoBlocks.hp_secondblock_single && 
            <div className="section promoblock section--altBg kumi_Section">
                <div className="flex-container">
                    <div className="flex-row flex-row--align-v-center ">
                        <div className="flex-col-sm-6 kumi-desc">
                            <img
                                className="kumi-logo"
                                src={
                                    lang.home.promoBlocks.hp_secondblock_single
                                        .logo
                                }
                                alt={
                                    lang.home.promoBlocks.hp_secondblock_single
                                        .alt
                                }
                            />
                            <p>
                                {
                                    lang.home.promoBlocks.hp_secondblock_single
                                        .desc
                                }
                            </p>

                            <Link
                                to={`/${lang.getLanguage()}/toys/${
                                    lang.home.promoBlocks.hp_secondblock_single
                                        .productId
                                }`}>
                                <button>
                                    {
                                        lang.home.promoBlocks
                                            .hp_secondblock_single.cta
                                    }
                                </button>
                               
                            </Link>
                        </div>
                        <div className="flex-col-sm-6">
                            <img
                                className="imageclass"
                                src={
                                    lang.home.promoBlocks.hp_secondblock_single
                                        .img
                                }
                                alt={
                                    lang.home.promoBlocks.hp_secondblock_single
                                        .title
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
            }
            {/*TEST 2-Block PROMO SECTION************************************************************/}
            
            {lang.home.promoBlocks.hp_thirdblock_single && (
                <div className="section promoblock section--altBg ">
                    <div className="flex-container">
                        <div className="flex-row">
                            <div className="flex-col-sm-8">
                                <img
                                    className="imageclass2"
                                    src={
                                        lang.home.promoBlocks
                                            .hp_thirdblock_single.img
                                    }
                                    alt={
                                        lang.home.promoBlocks
                                            .hp_thirdblock_single.alt
                                    }
                                />
                            </div>
                            <div className="flex-col-sm-4 mod-centered flex-direction-column">
                                <h2 className="text_pink">
                                    {
                                        lang.home.promoBlocks
                                            .hp_thirdblock_single.title
                                    }
                                </h2>
                                <div>
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => {
                                            this.props.dispatch(
                                                toggleInterstitial(
                                                    true,
                                                    lang.home.promoBlocks
                                                        .hp_thirdblock_single
                                                        .cta_link
                                                )
                                            );
                                        }}>
                                        <button>
                                            {
                                                lang.home.promoBlocks
                                                    .hp_thirdblock_single.cta
                                            }
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/*TEST 2-Block PROMO SECTION************************************************************/}
            {lang.home.promoBlocks.hp_thirdblock_double && (
                <div className="section promoblock double_promo_section">
                    <div className="flex-container">
                        <div className="flex-row">
                            {lang.home.promoBlocks.hp_thirdblock_double.map(
                                (promo, index) => (
                                    <div
                                        className="flex-col-sm-6 mod-centered"
                                        key={`promoblock___${index}`}>
                                        <div className="flex-row flex-row--align-v-column">
                                            <div className="promo_doubleimg">
                                                <img
                                                    src={promo.img}
                                                    alt={promo.title}
                                                />
                                            </div>
                                            <div className="promo_words">
                                                <h2>{promo.title}</h2>
                                                <p>{promo.desc}</p>
                                               <Link
                                                    to={`/${lang.getLanguage()}/toys/${
                                                        promo.productId
                                                    }`}>
                                                    <button>{promo.cta}</button>
                                                </Link>
                                               
                                            </div>
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/*TEST PROMO SECTION************************************************************/}
            {lang.home.promoBlocks.hp_fourthblock_single && (
                <div className="section promoblock section--altBg youtube_Section">
                    <div className="flex-container">
                        <div className="flex-row">
                            <div className="flex-col-sm-8">
                                <img
                                    className="imageclass"
                                    src={
                                        lang.home.promoBlocks
                                            .hp_fourthblock_single.img
                                    }
                                    alt={
                                        lang.home.promoBlocks
                                            .hp_fourthblock_single.alt
                                    }
                                />
                            </div>
                            <div className="flex-col-sm-4 mod-centered flex-direction-column">
                                <h2 className="text_pink">
                                    {
                                        lang.home.promoBlocks
                                            .hp_fourthblock_single.title
                                    }
                                </h2>
                                <div>
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => {
                                            this.props.dispatch(
                                                toggleInterstitial(
                                                    true,
                                                    lang.home.promoBlocks
                                                        .hp_fourthblock_single
                                                        .cta_link
                                                )
                                            );
                                        }}>
                                        <button>
                                            {
                                                lang.home.promoBlocks
                                                    .hp_fourthblock_single.cta
                                            }
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!!lang.home.promoBlocks.giphy_block && 
                <div className={`section promoblock section--altBg ${lang.home.promoBlocks.giphy_block.class}`}>
                    <div className="flex-container">
                        <div className="flex-row">
                            <div className="giphy-content-wrapper">
                                <div className='giphy-image-wrapper'>
                                    <img
                                        className="imageclass"
                                        src={
                                            lang.home.promoBlocks
                                                .giphy_block.img
                                        }
                                        alt={
                                            lang.home.promoBlocks
                                                .giphy_block.alt
                                        }
                                    />
                                </div>
                                <h2>
                                {lang.home.promoBlocks.giphy_block.title}
                                </h2>
                                <a 
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => {
                                        this.props.dispatch(
                                            toggleInterstitial(
                                                true,
                                                lang.home.promoBlocks
                                                    .giphy_block
                                                    .cta_link
                                            )
                                        );
                                    }}>
                                    <button>
                                        {
                                            lang.home.promoBlocks
                                                .giphy_block.cta
                                        }
                                    </button>
                                </a>
                            </div>

                        </div>
                    </div>

                </div> 
                }
            

            {/*PRODUCT CAROUSEL************************************************************/}
            <div className="section hp_prodcaro">
                <Productcaro />
            </div>
                <div className="wtb_extra">
                    <WhereToBuy />
                </div>
        </div>
    );
  }
}

function mapStateToProps(state) {
  return { 
    lang: state.lang,
    gaToggle: state.gaToggle

  };
}

export default connect(mapStateToProps)(Home);
